import { useState } from "react";
import { SerialProcessGuidedTour } from "components/SimpleComponents/GuidedTour/GuidedTours";
import IsSerialProcessindicator from "components/SimpleComponents/TopBanner/IsSerialProcessIndicator";
import { useDispatch } from "react-redux";
import { useSelector } from "store/useSelector";
import { updateIsSerialProcessIndicatorOpen } from "providers/GlobalStateProvider";
import { useSettings } from "contexts/SettingsManager/SettingsManager";

const SerialProcessInfo = () => {
  const [isSerialProcessTourEnabled, setIsSerialProcessTourEnabled] =
    useState(false);
  const dispatch = useDispatch();
  const { isTourEnabled } = useSettings();
  const isSerialProcessIndicatorOpen =
    useSelector(s => s.legacy.isSerialProcessIndicatorOpen) && isTourEnabled;
  return (
    <>
      <IsSerialProcessindicator
        isIndicatorOpen={isSerialProcessIndicatorOpen}
        setIsIndicatorOpen={val =>
          dispatch(updateIsSerialProcessIndicatorOpen(val))
        }
        setIsSerialProcessTourEnabled={setIsSerialProcessTourEnabled}
      />
      {isSerialProcessTourEnabled && (
        <SerialProcessGuidedTour
          setIsTourEnabled={setIsSerialProcessTourEnabled}
        />
      )}
    </>
  );
};

export default SerialProcessInfo;
